import { MessageStore } from './message-store';

export class Queue extends MessageStore {
  MaxSize: number;
  IsPartitioned: boolean;
  Size: number;
}
